<template>
    <button type="button" @click="$emit('click')"
            class="ml-6 inline-flex items-center px-4 py-2 space-x-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-black border-red-300 bg-red-100 hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-400">
        <div class="items-center">
            <slot name="icon"></slot><slot>BUTTON TEXT</slot>
        </div>
    </button>
</template>

<script>
export default {
    name: "ButtonDelete"
}
</script>

<style scoped>

</style>
